var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#question_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFF6FF",
    d: "M52 28C52 14.745 41.255 4 28 4S4 14.745 4 28s10.745 24 24 24 24-10.745 24-24"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DBEAFE",
    strokeWidth: 8,
    d: "M52 28C52 14.745 41.255 4 28 4S4 14.745 4 28s10.745 24 24 24 24-10.745 24-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5A94E1",
    d: "M26.985 33C25.891 33 25 33.91 25 35c0 1.067.861 2 1.985 2S29 36.067 29 35.008A2.026 2.026 0 0 0 26.985 33M27.327 18C24.36 18 23 20.023 23 21.386c0 .986.724 1.443 1.316 1.443 1.184 0 .706-1.943 2.942-1.943 1.095 0 1.977.558 1.977 1.718 0 1.363-1.228 2.146-1.952 2.857-.636.63-1.474 1.667-1.474 3.842 0 1.313.309 1.697 1.21 1.697 1.076 0 1.297-.558 1.297-1.037 0-1.312.025-2.073 1.228-3.161.592-.53 2.456-2.248 2.456-4.626S30.136 18 27.327 18"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "question_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
};
export default SvgQuestion;